const Menu = [
  { path: '/loan', icon: 'fa-solid fa-money-bill', title: '대출신청',
    children: [
      { path: '/loan/loan_001', title: '대출접수현황' },
      { path: '/loan/loan_002', title: '대출신청' }      
    ]
  },
  { path: '/bond', icon: 'fa-solid fa-magnifying-glass-dollar', title: '대출채권 조회',
    children: [
      { path: '/bond/bond_001', title: '대출채권 조회' }
    ]
  },
  { path: '/sanc', icon: 'fa-solid fa-pen-to-square', title: '결재함',
    children: [
      { path: '/sanc/sanc_001', title: '나의 결재 요청' },
      { path: '/sanc/sanc_002', title: '결재 대기' },
      { path: '/sanc/sanc_003', title: '결재선 관리' }
    ]
  },
  { path: '/base', icon: 'fa-solid fa-people-group', title: '직원관리',
    children: [
      { path: '/base/base_003', title: '직원관리' }
    ]
  },
  { path: '/acct', icon: 'fa-solid fa-hand-holding-dollar', title: '수납관리',
    children: [
      { path: '/acct/acct_001', title: '모계좌관리' },
      { path: '/acct/acct_002', title: '수납내역' }
    ]
  },
  { path: '/prop', icon: 'fa-solid fa-warehouse', title: '자산관리',
    children: [
      { path: '/prop/prop_001', title: '담보물 관리' },
      { path: '/prop/prop_002', title: '보관함 관리' }
    ]
  },
  { path: '/rpt', icon: 'fa-solid fa-file-lines', title: '보고서',
    children: [
      { path: '/rpt/rpt_001', title: '영업일보' },
      { path: '/rpt/rpt_002', title: '점포별 대출현황' }
    ]
  },
  { path: '/setting', icon: 'fa-solid fa-gear', title: '환경설정',
    children: [
      { path: '/setting/01', title: '메뉴 권한 관리' },
      { path: '/setting/02', title: '수수료 관리' }
    ]
  },
  // { path: '/user', icon: 'fa fa-key', title: 'Login & Register',
  //   children: [
  //     { path: '/user/login-v2', title: 'Login v2' },
  //     { path: '/user/register-v3', title: 'Register v3' }
  //   ]
  // },
]

export default Menu;